import { render } from "./Card4.vue?vue&type=template&id=12253b51"
import script from "./Card4.vue?vue&type=script&lang=ts"
export * from "./Card4.vue?vue&type=script&lang=ts"
script.render = render

export default script